export default __webpack_public_path__ + "static/mobileBanner2-9e62871448c0cd8403acd18f8fcd3b94.jpg";